// One indirection for "drive the simulator", so the rest of the app doesn't care WHERE the sim runs.
// When the browser sim is active (cloud/phone deployment, testing toggle on) the commands drive it
// locally; otherwise they fall through to the server sim endpoints (local dev with FLA_GNSS_SOURCE=
// sim). Callers (`store`, `DrivingHud`) import these instead of the raw `api` sim helpers.
import type { LonLat } from '@fla/core';
import * as server from '../api';
import { clientSim } from './clientSim';

export const simDrive = (path: LonLat[], opts: { speedMps?: number; offsetM?: number } = {}) =>
  clientSim.active ? clientSim.drive(path, opts) : void server.simDrive(path, opts);
export const simStop = () => (clientSim.active ? clientSim.stopDriving() : void server.simStop());
export const simNudge = (delta: number) =>
  clientSim.active ? clientSim.nudge(delta) : void server.simNudge(delta);
export const simOffset = (m: number) =>
  clientSim.active ? clientSim.setOffset(m) : void server.simOffset(m);
export const simSpeed = (mps: number) =>
  clientSim.active ? clientSim.setSpeed(mps) : void server.simSpeed(mps);
